import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
    loginbutton: {
        width: '100%',
        height: '56px !important',
        borderRadius: '14px !important',
        background: 'linear-gradient(135deg, #5b7ab8 0%, #3c5a98 100%) !important',
        color: '#ffffff !important',
        fontSize: '16px !important',
        fontWeight: '600 !important',
        textTransform: 'none !important',
        boxShadow: '0 10px 30px -10px rgba(60, 90, 152, 0.5) !important',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important',
        border: 'none !important',
        '&:hover': {
            background: 'linear-gradient(135deg, #4a6a9e 0%, #2d4578 100%) !important',
            boxShadow: '0 15px 40px -10px rgba(60, 90, 152, 0.6) !important',
            transform: 'translateY(-2px)',
        },
        '&:active': {
            transform: 'translateY(0)',
        }
    },
    loginerror: {
        fontSize: "14px",
        textAlign: "center",
        color: "#dc2626",
        padding: "12px 16px",
        marginBottom: "24px",
        background: "linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)",
        borderRadius: "12px",
        fontWeight: 500,
    },
    loginsuccess: {
        fontSize: "14px",
        textAlign: "center",
        color: "#16a34a",
        padding: "12px 16px",
        marginBottom: "24px",
        background: "linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%)",
        borderRadius: "12px",
        fontWeight: 500,
    },
    logout: {
        color: `#000000 !important`
    },
    buttonpan: {
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        marginTop: "8px",
    },
    forgot: {
        color: '#3c5a98 !important',
        fontSize: '14px !important',
        fontWeight: '500 !important',
        textTransform: 'none !important',
        padding: '8px !important',
        borderRadius: '10px !important',
        transition: 'all 0.2s ease !important',
        '&:hover': {
            background: 'rgba(60, 90, 152, 0.08) !important',
            color: '#2d4578 !important',
        }
    },
    back: {
        marginLeft: "20px  !important",
    }
}));